import React, { useState } from "react";
import { Button, Form, InputGroup, Table, Offcanvas, Accordion } from "react-bootstrap";
import PrimarySidebar from "../PrimarySidebar/PrimarySidebar";
import { BsSearch } from "react-icons/bs";

const initialLeads = [
  {
    id: 1,
    name: "John Doe",
    email: "john@example.com",
    phone: "123-456-7890",
    source: "LeadStream",
    status: "Accepted",
    protitle: "E-commerce Website Development",
    budget: "$10,000 - $20,000",
    hourlyRate: "$50 - $100/hr",
    location: "Remote",
    description: "Looking for an experienced web development team to build a scalable e-commerce platform with payment integration.",
    lookingToStart: "immediately",
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    phone: "987-654-3210",
    source: "Referral",
    status: "Qualified",
    protitle: "Mobile App for Fitness Tracking",
    budget: "$5,000 - $15,000",
    hourlyRate: "$40 - $80/hr",
    location: "United States",
    description: "Need a cross-platform mobile app for tracking workouts, diet plans, and progress with AI-based recommendations.",
    lookingToStart: "30_60",
  },
  {
    id: 3,
    name: "Alice Johnson",
    email: "alice@example.com",
    phone: "111-222-3333",
    source: "LinkedIn",
    status: "Engaged",
    protitle: "React Native Support",
    budget: "$5,000 - $15,000",
    hourlyRate: "$40 - $80/hr",
    location: "United States",
    description: "Need a cross-platform mobile app for tracking workouts, diet plans, and progress with AI-based recommendations.",
    lookingToStart: "30_60",
  },
  {
    id: 4,
    name: "Bob Brown",
    email: "bob@example.com",
    phone: "444-555-6666",
    source: "Facebook",
    status: "On Hold",
    protitle: "AWS Architecture Design",
    budget: "$5,000 - $15,000",
    hourlyRate: "$40 - $80/hr",
    location: "United States",
    description: "Need a cross-platform mobile app for tracking workouts, diet plans, and progress with AI-based recommendations.",
    lookingToStart: "30_60",
  },
];

const statusOptions = ["Accepted", "Qualified", "Engaged", "On Hold", "Inactive", "Project Completed", "Disqualified"];
const sourceOptions = ["Website", "Referral", "LinkedIn", "Facebook", "Instagram", "--None--"];

const LeadCrm = () => {
  const [leads, setLeads] = useState(initialLeads);
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterSource, setFilterSource] = useState("");
  const [showCanvas1, setShowCanvas1] = useState(false); // Canvas1 for viewing lead details
  const [showCanvas2, setShowCanvas2] = useState(false); // Canvas2 for adding lead
  const [selectedLead, setSelectedLead] = useState(null);
  const [showLogForm, setShowLogForm] = useState(false); // State to toggle log form
  const [logEntry, setLogEntry] = useState("");
  const [newLead, setNewLead] = useState({
    name: "",
    designation: "",
    phone: "",
    email: "",
    status: "Accepted",
    companyName: "",
    noOfEmployees: "",
    annualRevenue: "",
    serviceName: "",
    industry: "",
    source: "--None--",
    linkedinURL: "",
    comments: "",
    budget: "",
    need: "",
    description: "",
    companyAddress: "",
  });

  const handleDelete = (id) => {
    setLeads(leads.filter((lead) => lead.id !== id));
  };

  const handleAddLead = () => {
    setLeads([...leads, { id: leads.length + 1, ...newLead }]);
    setShowCanvas2(false);
    setNewLead({
      name: "",
      designation: "",
      phone: "",
      email: "",
      status: "Accepted",
      companyName: "",
      noOfEmployees: "",
      annualRevenue: "",
      serviceName: "",
      industry: "",
      source: "--None--",
      linkedinURL: "",
      comments: "",
      budget: "",
      need: "",
      description: "",
      companyAddress: "",
    });
  };

  const handleViewLead = (lead) => {
    setSelectedLead(lead);
    setShowCanvas1(true);
  };

  const filteredLeads = leads.filter(
    (lead) =>
      (filterStatus === "" || lead.status === filterStatus) &&
      (filterSource === "" || lead.source === filterSource) &&
      (lead.name.toLowerCase().includes(search.toLowerCase()) || lead.email.toLowerCase().includes(search.toLowerCase()))
  );

  const handleAddLog = () => {
    if (logEntry.trim() && selectedLead) {
      const newLog = {
        text: logEntry,
        timestamp: new Date().toISOString()
      };

      const updatedLeads = leads.map(lead =>
        lead.id === selectedLead.id
          ? { ...lead, logs: [...(lead.logs || []), newLog] }
          : lead
      );

      setLeads(updatedLeads);
      setSelectedLead({
        ...selectedLead,
        logs: [...(selectedLead.logs || []), newLog]
      });
      setLogEntry("");
    }
  };





  return (
    <>
      <PrimarySidebar />
      <div className="js-pg-hg mt-5 container cp-container">
        <div className="d-flex justify-content-between mb-4">
          <div className="heading pb-1">
            <h4>Lead CRM</h4>
          </div>

        </div>

        {/* Search Bar */}
        <div className="p-4 shadow-sm rounded-3 bg-white mb-5">
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search Lead..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Button variant="primary" className="px-4">
              <BsSearch />
            </Button>
          </InputGroup>
        </div>

        <div className="mt-4">


          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-2">
              <Form.Select
                value={filterSource}
                onChange={(e) => setFilterSource(e.target.value)}
                style={{ minWidth: "150px" }}
              >
                <option value="">All Sources</option>
                {sourceOptions.map((source) => (
                  <option key={source} value={source}>{source}</option>
                ))}
              </Form.Select>
              <Form.Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                style={{ minWidth: "150px" }}
              >
                <option value="">All Status</option>
                {statusOptions.map((status) => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </Form.Select>
            </div>
            <div>
              <Button variant="outline-primary text-primary" size="md" onClick={() => setShowCanvas2(true)}>
                Add Lead
              </Button>
            </div>
          </div>




          {/* Leads Table */}
          <Table striped bordered hover className="rounded-4 shadow-sm">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Source</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredLeads.map((lead) => (
                <tr key={lead.id}>
                  <td>{lead.name}</td>
                  <td>{lead.email}</td>
                  <td>{lead.phone}</td>
                  <td>{lead.source}</td>
                  <td>
                    <Form.Select
                      value={lead.status}
                      onChange={(e) =>
                        setLeads(leads.map((l) => (l.id === lead.id ? { ...l, status: e.target.value } : l)))
                      }
                    >
                      {statusOptions.map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                  <td className="d-flex justify-content-center">
                    <Button variant="outline-primary text-primary" onClick={() => handleViewLead(lead)}>
                      View
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

















          {/* Canvas1: Lead Details */}
          <Offcanvas
            show={showCanvas1}
            onHide={() => setShowCanvas1(false)}
            placement="end"
            style={{ width: "650px" }}
            className="shadow-lg border-0"
          >
            <Offcanvas.Header closeButton className="px-5 py-4 bg-skyblue rounded-top-3">
              <Offcanvas.Title className="fw-600 fs-4">Lead Details</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="px-5 py-4 bg-light">
              {selectedLead && (
                <div>
                  <div className="mb-4">

                    <div className="d-flex card shadow-sm p-4 flex-column gap-2">
                      <p className="p-0 m-0 d-flex border-bottom justify-content-between pb-3 mb-2">
                        <span className="text-muted">Name</span>{" "}
                        <span className="text-dark fw-600">{selectedLead.name}</span>
                      </p>
                      <p className="p-0 m-0 d-flex border-bottom justify-content-between pb-3 mb-2">
                        <span className="text-muted">Email</span>{" "}
                        <span className="text-dark fw-600">{selectedLead.email}</span>
                      </p>
                      <p className="p-0 m-0 d-flex border-bottom justify-content-between pb-3 mb-2">
                        <span className="text-muted">Phone</span>{" "}
                        <span className="text-dark fw-600">{selectedLead.phone}</span>
                      </p>
                      <p className="p-0 m-0 d-flex justify-content-between">
                        <span className="text-muted">Source</span>{" "}
                        <span className="text-dark fw-600 text-end">{selectedLead.source}</span>
                      </p>
                    </div>
                    <div className="mt-3">
   <h6 className="m-0 py-2">Status</h6>
   <select class="form-select">
                      <option value="Accepted">Accepted</option>
                      <option value="Qualified">Qualified</option>
                      <option value="Engaged">Engaged</option>
                      <option value="On Hold">On Hold</option>
                      <option value="Inactive">Inactive</option>
                      <option value="Project Completed">Project Completed</option>
                      <option value="Disqualified">Disqualified</option>
                      </select>
                    </div>

                  </div>

                  <hr className="my-4 border-secondary" />

                  <div>
                    <h5 className="fw-600 text-dark mb-3">{selectedLead.protitle}</h5>
                    <div className="badge bg-outline-primary text-primary mb-3 px-2 bg-white rounded-3">
                      {selectedLead.lookingToStart === "immediately"
                        ? "Immediate"
                        : selectedLead.lookingToStart.replace("_", "-") + " days"}
                    </div>
                    <p className="text-muted mb-3">{selectedLead.description}</p>
                    <div className="bg-white p-3 rounded-3 border">
                      <ul className="list-unstyled m-0">
                        <li className="d-flex justify-content-between py-2 border-bottom">
                          <span className="text-muted">Budget</span>
                          <span className="text-dark fw-600 text-end">{selectedLead.budget}</span>
                        </li>
                        <li className="d-flex justify-content-between py-2 border-bottom">
                          <span className="text-muted">Hourly Rate</span>
                          <span className="text-dark fw-600 text-end">{selectedLead.hourlyRate}</span>
                        </li>
                        <li className="d-flex justify-content-between py-2 border-bottom">
                          <span className="text-muted">Location</span>
                          <span className="text-dark fw-600 text-end">{selectedLead.location}</span>
                        </li>
                        <li className="d-flex justify-content-between py-2">
                          <span className="text-muted">Posted Date</span>
                          <span className="text-dark fw-600 text-end">Feb 14 2024</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Logs Section */}
                  <div className="mt-4">
                    <div className="p-3 bg-white rounded-3 border shadow-sm">
                      <Form.Group className="mb-3">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={logEntry}
                          onChange={(e) => setLogEntry(e.target.value)}
                          placeholder="Add Log"
                        />
                      </Form.Group>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          className="px-4 py-2 fw-medium rounded-3"
                          onClick={handleAddLog}
                        >
                          Log
                        </Button>
                      </div>
                    </div>

                    {/* Saved Logs Display */}
                    {selectedLead.logs && selectedLead.logs.length > 0 && (
                      <div className="mt-5">
                        <h5 className="fw-600 text-dark mb-3">Log History</h5>
                        <div className="bg-white p-3 rounded-3 border-bottom shadow-sm">
                          {selectedLead.logs.map((log, index) => (
                            <div key={index} className="p-2">
                              <p className="mb-1 text-dark">{log.text}</p>
                              <small className="text-secondary">
                                {new Date(log.timestamp).toLocaleString()}
                              </small>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Offcanvas.Body>
          </Offcanvas>

          {/* Canvas2: Add Lead Form */}
          <Offcanvas
            show={showCanvas2}
            onHide={() => setShowCanvas2(false)}
            placement="end"
            style={{ width: "650px" }}
            className="shadow-lg border-0"
          >
            <Offcanvas.Header closeButton className="px-5 py-4 bg-skyblue rounded-top-3">
              <Offcanvas.Title className="fw-600 fs-4">Add New Lead</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="px-5 py-4 bg-light">
              <Form>
                {/* Contact Details Accordion */}
                <Accordion defaultActiveKey="0" className="mb-3">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Contact Details</Accordion.Header>
                    <Accordion.Body>
                      <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.name}
                          onChange={(e) => setNewLead({ ...newLead, name: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Designation</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.designation}
                          onChange={(e) => setNewLead({ ...newLead, designation: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Phone No</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.phone}
                          onChange={(e) => setNewLead({ ...newLead, phone: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          value={newLead.email}
                          onChange={(e) => setNewLead({ ...newLead, email: e.target.value })}
                        />
                      </Form.Group>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* Company Details Accordion */}
                <Accordion className="mb-3">
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Company Details</Accordion.Header>
                    <Accordion.Body>
                      <Form.Group className="mb-3">
                        <Form.Label>Company Name</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.companyName}
                          onChange={(e) => setNewLead({ ...newLead, companyName: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>No. of Employees</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.noOfEmployees}
                          onChange={(e) => setNewLead({ ...newLead, noOfEmployees: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Annual Revenue</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.annualRevenue}
                          onChange={(e) => setNewLead({ ...newLead, annualRevenue: e.target.value })}
                        />
                      </Form.Group>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* Services Needed Accordion */}
                <Accordion className="mb-3">
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>Services Needed</Accordion.Header>
                    <Accordion.Body>
                      <Form.Group className="mb-3">
                        <Form.Label>Service Name</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.serviceName}
                          onChange={(e) => setNewLead({ ...newLead, serviceName: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Industry</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.industry}
                          onChange={(e) => setNewLead({ ...newLead, industry: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Lead Status</Form.Label>
                        <Form.Select
                          value={newLead.status}
                          onChange={(e) => setNewLead({ ...newLead, status: e.target.value })}
                        >
                          {statusOptions.map((status) => (
                            <option key={status} value={status}>
                              {status}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Lead Source</Form.Label>
                        <Form.Select
                          value={newLead.source}
                          onChange={(e) => setNewLead({ ...newLead, source: e.target.value })}
                        >
                          {sourceOptions.map((source) => (
                            <option key={source} value={source}>
                              {source}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* Qualifiers Accordion */}
                <Accordion className="mb-3">
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>Qualifiers</Accordion.Header>
                    <Accordion.Body>
                      <Form.Group className="mb-3">
                        <Form.Label>Budget</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.budget}
                          onChange={(e) => setNewLead({ ...newLead, budget: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Need</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.need}
                          onChange={(e) => setNewLead({ ...newLead, need: e.target.value })}
                        />
                      </Form.Group>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* Description Accordion */}
                <Accordion className="mb-3">
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>Description</Accordion.Header>
                    <Accordion.Body>
                      <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Leave a comment here"
                          value={newLead.description}
                          onChange={(e) => setNewLead({ ...newLead, description: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Company Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={newLead.companyAddress}
                          onChange={(e) => setNewLead({ ...newLead, companyAddress: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Linkedin URL</Form.Label>
                        <Form.Control
                          type="text"
                          value={newLead.linkedinURL}
                          onChange={(e) => setNewLead({ ...newLead, linkedinURL: e.target.value })}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Comments</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={newLead.comments}
                          onChange={(e) => setNewLead({ ...newLead, comments: e.target.value })}
                        />
                      </Form.Group>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* Action Buttons */}
                <div className="d-flex justify-content-end mt-5">
                  <Button
                    variant="outline-secondary"
                    className="px-4 py-2 fw-medium rounded-3 me-3"
                    onClick={() => setShowCanvas2(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    className="px-4 py-2 fw-medium rounded-3"
                    onClick={handleAddLead}
                  >
                    Add Lead
                  </Button>
                </div>
              </Form>
            </Offcanvas.Body>
          </Offcanvas>


















        </div>
      </div>
    </>
  );
};

export default LeadCrm;